var ApolloLinkSequence = function(jQ) {

  function initFileLinkSequence() {
    var $linksequence = jQ('.whc-filelist');
    var $fileLinkDatas = jQ('.whc-filelist-item');
    var $ddlYear;
    $ddlYear = jQ('#ddl-year');

    function updateDdlYear() {
      var years = [];
      $.each($fileLinkDatas, function() {
        var year = jQ(this).attr('data-year');
        if (year) years.push(year);
      });
      years = $.grep(years, function(v, k) {
        return $.inArray(v, years) === k;
      }).sort(function(a, b){return b-a});
      $ddlYear.find('option').not(':first').remove();
      $.each(years, function(i, item) {
        $ddlYear.append(jQ('<option>', {
          value: item,
          text: item
        }));
      });
    }

    function changeDdlYearHandler() {
        updateFileLinkSequence();
    }

    function updateFileLinkSequence() {
      if ($ddlYear.val() != "") {
        jQ('.whc-filelist-item:not([data-year="' + $ddlYear.val() + '"])').hide();
        jQ('.whc-filelist-item[data-year="' + $ddlYear.val() + '"]').show();
      }
    }

    if ($ddlYear && $ddlYear.length) {
      $ddlYear.on('change', changeDdlYearHandler);
      updateDdlYear();
      $ddlYear.find('option:eq(1)').attr('selected', 'selected');
      updateFileLinkSequence();
    }

  }

  function init() {
    if (DEBUG) { console.info("ApolloLinkSequence.init()"); }

    initFileLinkSequence();
  }

  // public available functions
  return {
    init: init
  }

}(jQuery);
